<template>
    <div ref="container">
        <div data-slide class="w-full h-full relative flex flex-col-reverse lg:flex-row" v-for="(slide,i) in slides" :key="`slide-${i}`">
            <div v-if="slides.length > 1 || slide.caption || slide.photoCredit" data-slide-aside class="relative lg:w-58 lg:border-r lg:border-white-20">
                <div v-if="slide.caption || slide.photoCredit"
                     data-caption
                     :class="{
                        'mb-14': slides.length > 1,
                     }"
                     class="lg:absolute bottom-0 p-9 bg-black">
                    <div class="text-10 font-light text-white-fd tracking-uppercase leading-loose uppercase">{{ slide.caption }}</div>
                    <div class="text-12 font-thin italic text-grey-c5cebe tracking-wide leading-relaxed">{{ slide.photoCredit }}</div>
                </div>
                <div v-if="slides.length > 1" data-counter class="absolute bottom-0 right-0 p-9 mb-2">
                    <div class="text-white text-14 tracking-wide leading-relaxed">{{ i+1 }} / {{ slides.length }}</div>
                </div>
            </div>
            <div class="flex-1 min-h-0 flex justify-center items-center m-0">
                <img
                    :alt="slide.alt || ''"
                    :sizes="sizes[i]"
                    :data-flickity-lazyload-src="slide.src"
                    :data-flickity-lazyload-srcset="slide.srcset || null"
                    class="block w-full h-full lazyload max-w-full object-scale-down">
            </div>
        </div>
    </div>
</template>

<script>

import Flickity from 'flickity-fade';
import "flickity/css/flickity.css";
import "flickity-fade/flickity-fade.css";
import "@css/components/flickity-overrides.scss";

export default {
    props: {
        slides: {
            type: Array,
            default: () => [],
        },
        // One CSS width per slide, so the browser can pick a srcset candidate
        // before it knows anything about the box it will end up in.
        sizes: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            flkty: false,
            observer: null,
            asideHeight: null,
        }
    },
    mounted() {
        this.flkty = new Flickity( this.$refs.container, {
            cellSelector: '[data-slide]',
            pageDots: false,
            adaptiveHeight: false,
            wrapAround: true,
            fade: true,
            setGallerySize: false,
            //contain: true,
            lazyLoad: 2,
            arrowShape: {
                x0: 20,
                x1: 50, y1: 20,
                x2: 80, y2: 40,
                x3: 80
            },
        });

        this.flkty.on( 'select', this.onSelect );
        this.observeAsides();
        this.onSelect();
    },
    beforeDestroy() {
        this.flkty.off( 'select', this.onSelect );

        if ( this.observer ) {
            this.observer.disconnect();
        }

        this.flkty.destroy();
    },
    methods: {
        onSelect() {
            this.reportSlideSize();
            this.reportAsideHeight();
        },

        // Below lg the caption stacks beneath the photo, and how tall it wraps
        // depends on the box width the modal is still deciding on. Watching it
        // settles the two against each other in a frame or two.
        observeAsides() {
            if ( typeof ResizeObserver === 'undefined' ) {
                return;
            }

            this.observer = new ResizeObserver( () => this.reportAsideHeight() );
            this.$el.querySelectorAll('[data-slide-aside]').forEach( aside => this.observer.observe( aside ) );
        },

        reportAsideHeight() {
            const cell = this.flkty && this.flkty.selectedElement;
            const aside = cell ? cell.querySelector('[data-slide-aside]') : null;
            const height = aside ? aside.offsetHeight : 0;

            if ( height !== this.asideHeight ) {
                this.asideHeight = height;
                this.$emit('aside-height', height);
            }
        },

        // The modal hugs the photo rather than letterboxing it, so it needs the
        // asset's own dimensions. Not the image's naturalWidth: that describes
        // whichever srcset candidate the browser picked, so a small one would
        // shrink the box.
        reportSlideSize() {
            const slide = this.slides[ this.flkty.selectedIndex ] || {};

            if ( slide.width && slide.height ) {
                this.$emit('slide-size', {
                    aspect: slide.width / slide.height,
                    height: slide.height,
                });
            }
        },
    }
}
</script>